import React from 'react';
import {DataGrid} from '@internal/components';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CMSMetasAPI from '@internal/apis/CMSMetasAPI';
import type CMSMetasTypes from '@internal/types/CMSMetasTypes';
import type BasePageProps from '@internal/pages/BasePageProps';

const Metas: React.FC<BasePageProps> = ({navigatePage}) => {
  const [record, setRecord] = React.useState<CMSMetasTypes[]>([]);
  const loadRecords = async (
    refreshCache: boolean,
    page: number,
  ): Promise<number> => {
    setRecord(await CMSMetasAPI.getList(navigatePage, refreshCache, page));
    return await CMSMetasAPI.getPageNumbers();
  };

  return (
    <DataGrid
      sm={4}
      itemProps={[
        {type: 'data', key: 'name', text: 'Meta Name'},
        {type: 'data', key: 'contents', text: 'Meta Contents'},
      ]}
      items={record}
      itemActions={[
        {
          icon: <EditIcon color="primary" />,
          handler: async (id: any) => {
            navigatePage('/members/cms/metas/update/' + id);
          },
        },
        {
          icon: <DeleteIcon color="primary" />,
          handler: async (id: any) => {
            if (await CMSMetasAPI.delete(navigatePage, id)) {
              await loadRecords(false, 1);
            }
          },
        },
      ]}
      addInfo={{
        text: 'Meta',
        handler: () => {
          navigatePage('add');
        },
      }}
      actionID={'id'}
      loadRecords={loadRecords}
      doShowCardHeader
      doShowTableHeader
    />
  );
};

export default Metas;
